/*
 * @Description:
 * @Author: cooky
 * @Date: 2021-02-25 17:17:51
 * @LastEditors: cooky
 * @LastEditTime: 2021-03-05 17:25:45
 */
import axios from '@/util/request'

const GOOGLE_LOGIN = '/login/GoogleLogin'
const FB_LOGIN = '/login/FacebookLogin'

export function googleLogin (data) {
  return axios.post(GOOGLE_LOGIN, data)
}

export function fbLogin (data) {
  return axios.post(FB_LOGIN, data)
}
